import { useFormContext } from "react-hook-form";

import {
  InputDateControllerRow,
  InputTextRow,
  SelectControllerRow,
} from "@components";

import { useEmployeeServiceData } from "@hooks/useEmployeeServiceData";
import { useLanguage } from "@hooks/useLanguage";

import { EMPLOYEE_SERVICE_DATA } from "@constants/employee-service-data";

import { getEmployeeServiceDataConvert } from "@helpers/employeeServiceDataConvert";
import { getConvertedFunctionalityData } from "@helpers/functionalityDataConvert";
import { getConvertedMasterData } from "@helpers/masterDataConvert";

import {
  ApplyLeaveFormDataType,
  BASIC_INFO,
} from "@validations/HRM/leave/applyLeaveFormValidation";

interface BasicInfoPropType {
  unitId: string | number;
  leaveType: any;
  leaveNature: any;
  isDisabled: boolean;
}

export const BasicInfo = ({
  unitId,
  leaveType,
  leaveNature,
  isDisabled,
}: BasicInfoPropType) => {
  const { language } = useLanguage();

  const {
    register,
    control,
    formState: { errors },
    setValue,
  } = useFormContext<ApplyLeaveFormDataType>();

  const { data: commonInfoResponse } = useEmployeeServiceData({
    dataType: EMPLOYEE_SERVICE_DATA.COMMON_INFO,
    unitId,
  });
  const commonInfo = commonInfoResponse?.commonInfo || [];

  return (
    <div className="d-flex flex-column gap-8 pb-8 border-bottom">
      <SelectControllerRow
        label="LEAVE_APPLY.FORM.BASIC_INFO.LEAVE_TYPE"
        name={BASIC_INFO.LEAVE_TYPE}
        register={{ ...register(BASIC_INFO.LEAVE_TYPE) }}
        options={getConvertedFunctionalityData(leaveType, language)}
        setValue={setValue}
        control={control}
        disabled={isDisabled}
      />
      <SelectControllerRow
        label="LEAVE_APPLY.FORM.BASIC_INFO.LEAVE_NATURE"
        name={BASIC_INFO.LEAVE_NATURE}
        register={{ ...register(BASIC_INFO.LEAVE_NATURE) }}
        options={getConvertedMasterData(leaveNature, language)}
        setValue={setValue}
        control={control}
        disabled={isDisabled}
      />
      <InputDateControllerRow
        label="LEAVE_APPLY.FORM.BASIC_INFO.FROM_DATE"
        control={control}
        register={{ ...register(BASIC_INFO.FROM_DATE) }}
        errors={errors}
        name={BASIC_INFO.FROM_DATE}
        disabled={isDisabled}
      />
      <InputDateControllerRow
        label="LEAVE_APPLY.FORM.BASIC_INFO.TO_DATE"
        control={control}
        register={{ ...register(BASIC_INFO.TO_DATE) }}
        errors={errors}
        name={BASIC_INFO.TO_DATE}
        disabled={isDisabled}
      />
      <InputTextRow
        register={{ ...register(BASIC_INFO.TOTAL_DAYS) }}
        label="LEAVE_APPLY.FORM.BASIC_INFO.DURATION"
        error={errors}
        disabled={isDisabled}
      />
      <SelectControllerRow
        label="LEAVE_APPLY.FORM.BASIC_INFO.DELEGATED_EMPLOYEE_NAME"
        name={BASIC_INFO.DELEGATED_EMPLOYEE_NAME}
        register={{ ...register(BASIC_INFO.DELEGATED_EMPLOYEE_NAME) }}
        options={getEmployeeServiceDataConvert(commonInfo, language)}
        setValue={setValue}
        control={control}
        disabled={isDisabled}
      />
      <InputTextRow
        register={{ ...register(BASIC_INFO.ADDRESS) }}
        label="LEAVE_APPLY.FORM.BASIC_INFO.ADDRESS"
        error={errors}
        disabled={isDisabled}
      />
      <InputTextRow
        register={{ ...register(BASIC_INFO.REASON) }}
        label="LEAVE_APPLY.FORM.BASIC_INFO.REASON"
        error={errors}
        disabled={isDisabled}
      />
    </div>
  );
};
